// maxinsights.ai is geo-blocked in mainland China; the .work apex is the
// accessible counterpart (same Cloudflare worker, mirrored custom domains in
// workers/wrangler.jsonc). A single built bundle serves BOTH TLDs, so every
// build-time `*.maxinsights.ai` host must be reconciled with whichever TLD the
// user actually loaded the page on, at runtime.

const AI_SUFFIX = '.maxinsights.ai';
const WORK_SUFFIX = '.maxinsights.work';

function currentHostname(): string {
  return typeof window === 'undefined' ? '' : window.location.hostname;
}

/** True when the page is currently served from a *.maxinsights.work host. */
export function isWorkDomain(hostname: string = currentHostname()): boolean {
  return hostname.endsWith(WORK_SUFFIX);
}

/**
 * Normalize a hostname to its canonical .ai form so the build-time .ai
 * whitelist matches regardless of which TLD the user loaded the page on.
 * Non-maxinsights hosts (localhost, IPs) are returned unchanged.
 */
export function toCanonicalAiHost(hostname: string = currentHostname()): string {
  return hostname.endsWith(WORK_SUFFIX)
    ? `${hostname.slice(0, -WORK_SUFFIX.length)}${AI_SUFFIX}`
    : hostname;
}

/**
 * Rewrite a build-time maxinsights.ai URL (or bare host) so its TLD matches the
 * page's current TLD. On a .work host, maxinsights.ai -> maxinsights.work;
 * otherwise the input is returned unchanged. Used for external counterparts
 * (Authentik, video-sage) that have their own .work mirror.
 */
export function toCurrentTld(urlOrHost: string): string {
  return isWorkDomain() ? urlOrHost.replace(/\.maxinsights\.ai/g, WORK_SUFFIX) : urlOrHost;
}
